import { ApiResponse, create } from 'apisauce'

import { webErrorsMonitor } from 'src/config/bugsnag'

export type Data<T> = {
  data: T
}

export type Response<T> = {
  data?: T
  error?: string
  status: number
}

// When the response time exceeds 1min, the server is responding with CORS error
const api = create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.toodo.com.br',
  timeout: 60000 // 1min
})

api.addMonitor(webErrorsMonitor)

type MakeProps<TResponseDataApi, TDataReturn> = {
  axiosCall: Promise<ApiResponse<TResponseDataApi>>

  transformError?: (e: unknown) => string
} & (TDataReturn extends TResponseDataApi
  ? Partial<TransformData<TResponseDataApi, TDataReturn>>
  : TransformData<TResponseDataApi, TDataReturn>)

type TransformData<TResponseDataApi, TDataReturn> = {
  transformData: (data: TResponseDataApi) => TDataReturn
}

/**
 * TResponseDataApi: type of data that api will return
 * TDataReturn: type of data that make() must return
 */
export async function make<TResponseDataApi, TDataReturn = TResponseDataApi>({
  axiosCall,
  transformData,
  transformError
}: MakeProps<TResponseDataApi, TDataReturn>): Promise<Response<TDataReturn>> {
  try {
    const { data, ok, status } = await axiosCall

    if (ok && data) {
      return {
        data: transformData
          ? transformData(data)
          : (data as unknown as TDataReturn),
        status: status || 200
      }
    }

    return {
      data: data as unknown as TDataReturn,
      status
    }
    // throw new Error('Unexpected error')
  } catch (e) {
    return {
      error: transformError ? transformError(e) : e.message,
      status: 500
    }
  }
}

export default api
